import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from '@aiwyn/shared';
import {
  CxpFilterChangeEvent,
  CxpFilterGroup,
  CxpTaskFilterKey,
  CxpTaskFilterSelection,
} from '../../../../models';

// Re-export for backwards-compatible imports while the rest of the codebase
// migrates to importing from `cxp/models` directly.
export type { CxpFilterChangeEvent, CxpFilterGroup, CxpFilterOption } from '../../../../models';

@Component({
  selector: 'cxp-task-filters-sidebar',
  templateUrl: './task-filters-sidebar.component.html',
  styleUrls: ['./task-filters-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckboxModule, SharedModule],
})
export class TaskFiltersSidebarComponent {
  readonly filterGroups = input<CxpFilterGroup[]>([]);
  readonly selectedFilters = input<CxpTaskFilterSelection>({});
  readonly filterChanged = output<CxpFilterChangeEvent>();

  isSelected(groupKey: CxpTaskFilterKey, optionId: number): boolean {
    return this.selectedFilters()[groupKey]?.has(optionId) ?? false;
  }

  onCheckboxChange(groupKey: CxpTaskFilterKey, optionId: number, checked: boolean): void {
    this.filterChanged.emit({ groupKey, optionId, selected: checked });
  }
}
